import React, { useState } from 'react';
import Modal from 'react-modal';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';
import '../../styles/CustomModal.css';

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
};

const SetItemGuideModal = ({ isVisible, setVisible }: Props) => {
  const onCloseModal = () => {
    setVisible(false);
  };

  return (
    <Modal
      isOpen={isVisible}
      onRequestClose={onCloseModal}
      className="setMenuGuideModal modal-content bottom"
      closeTimeoutMS={100}
      ariaHideApp={false}>
      <Style>
        <div className="modalWrapper">
          <img
            className="closeIcon"
            onClick={onCloseModal}
            src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`}
            alt="close"
          />
          <div className="modalTitle">
            <h4>세트메뉴 만드는 방법</h4>
            <div className="headerBar" />
          </div>
          <div className="modalContent">
            <div className="guide">
              <h4>
                <span>TIP!</span> &lt;세트상품&gt;을 먼저 만든 후 &lt;세트메뉴&gt;를 만들때
                불러와야합니다.
              </h4>
              <div className="textWrap">
                <h5>예시) 빙수+떡 세트</h5>
                <h5>{'\b\b\b\b\b\b구성- 빙수 + 떡1 + 떡2'}</h5>
              </div>
            </div>
            <div className="guide">
              <div className="row">
                <div className="stepBadge">STEP.1</div>
                <h4>&lt;세트상품관리&gt;에서 ‘세트상품 추가하기’를 눌러주세요.</h4>
              </div>
              <img src={`${process.env.PUBLIC_URL}/img/setItemGuide01.png`} alt="guide" />
            </div>
            <div className="guide">
              <div className="row">
                <div className="stepBadge">STEP.2</div>
                <h4>첫번째 세트구성을 먼저 만들거에요. 세트구성의 이름을 입력해주세요.</h4>
              </div>
              <img src={`${process.env.PUBLIC_URL}/img/setItemGuide02.png`} alt="guide" />
            </div>
            <div className="guide">
              <div className="row">
                <div className="stepBadge">STEP.3</div>
                <h4>옵션이 필수인지 아닌지 선택해주세요.</h4>
              </div>
              <img src={`${process.env.PUBLIC_URL}/img/setItemGuide03.png`} alt="guide" />
            </div>
            <div className="guide">
              <div className="row">
                <div className="stepBadge">STEP.4</div>
                <h4>
                  추가하실 상품을 선택해주세요. 미리보기에서 어떤 상품이 추가되었는지 확인
                  가능합니다.
                </h4>
              </div>
              <img src={`${process.env.PUBLIC_URL}/img/setItemGuide04.png`} alt="guide" />
            </div>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default SetItemGuideModal;

const Style = styled.div`
  .modalWrapper {
    position: relative;
    padding: 10px 40px;
    height: 80vh;
    overflow: auto;
    text-align: left;
  }
  .modalTitle {
    padding-bottom: 20px;
    .headerBar {
      width: 100%;
      height: 5px;
      margin: 0 auto;
      border-radius: 10px;
      background: #f7f7f7;
    }
    h4 {
      font-size: 20px;
      margin: 22px 0;
      font-weight: 600;
      color: #555;
    }
  }
  .row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-bottom: 10px;
  }

  /* modalContent */
  .guide {
    margin-bottom: 60px;
    h4 {
      font-weight: 500;
      color: #555555;
    }
    span {
      color: #4dd2ae;
    }
    .stepBadge {
      width: 60px;
      padding: 2px 0;
      background: #afafaf;
      border-radius: 3px;
      text-align: center;
      font-size: 14px;
      line-height: 20px;
      color: #ffffff;
      font-weight: 500;
    }
    .textWrap {
      padding-top: 20px;
      h5 {
        font-size: 16px;
        line-height: 24px;
        color: #979797;
        font-weight: 500;
      }
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
`;
